'use client';

import React from 'react';
import { cn } from '@/utils/cn';
import { formatPrice } from '@/utils/number';
// import styles from './emi_table.module.css';
import TableCellText from '../Typography/TableCellText';

import './emi_table.css';

function EmiTableDesktop({
  tenures = [],
  className = '',
  price = 0,
  isCart = true,
}) {
  if (tenures?.length === 0) {
    return null;
  }

  return (
    <div className={cn(className)}>
      <div>
        <div
          className="emi_table desktop_table custom-scrollbar-store lg:pb-24"
          role="region"
        >
          <table>
            <tbody>
              <tr>
                <td className="!bg-white border-r sticky_td">
                  <TableCellText text="Months" className="font-semibold" />
                </td>
                {tenures?.map((item, index) => {
                  const isLastItem = index === tenures.length - 1;
                  return (
                    <td
                      key={item.month}
                      className={cn('border-r', {
                        '!border-r-0': isLastItem,
                      })}
                    >
                      <TableCellText text={`${item.month} months`} />
                    </td>
                  );
                })}
              </tr>
              <tr>
                <td className="!bg-white border-t border-r border-b sticky_td">
                  <TableCellText
                    text={isCart ? 'Cart Price' : 'Product Price'}
                    className="font-semibold"
                  />
                </td>

                {tenures.map((item, index) => {
                  const isLastItem = index === tenures.length - 1;
                  return (
                    <td
                      key={item.id}
                      className={cn('border', {
                        '!border-r-0': isLastItem,
                      })}
                    >
                      <TableCellText text={`৳ ${formatPrice(price)}`} />
                    </td>
                  );
                })}
              </tr>

              <tr>
                <td className="!bg-white border-r sticky_td">
                  <TableCellText
                    text="Monthly Payment"
                    className="font-semibold "
                  />
                </td>
                {tenures?.map((item, index) => {
                  const isLastItem = index === tenures.length - 1;
                  return (
                    <td
                      key={item.id}
                      className={cn('!bg-[#FFEDEB] !border-r', {
                        '!border-r-0': isLastItem,
                      })}
                    >
                      <TableCellText text={`৳ ${formatPrice(item.monthly)}`} />
                    </td>
                  );
                })}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default EmiTableDesktop;
